/* eslint-disable no-useless-escape */
export default class ConstDef {
  static apiUrl = ''
  static apiUrlProduction = '/HighApi/restApi'
  static apiUrlEvaluationLocal = ':8082/restApi'
  static apiUrlEvaluation = 'https://biz.careerhighc.com/HighApi/restApi'

  static authUrl = ''
  static authUrlProduction = 'https://authmes.landk.co.kr/MesAuth/restApi'
  static authUrlEvaluation = 'http://localhost:8082/restApi'

  static stompPortProduction = '/HighApi/ws'
  static stompPortEvaluation = ':8082/ws'
  static manualUrl = ''
  static manualUrlProduction = ':8082/manual'
  static manualUrlEvaluation = ':4200/manual'
  static stompUrl = ''
  static DATA_BASE = 'HIGH_DB'
  static WEB_TAB_TITLE = 'Biz Plus'
  static TAB_TITLE = 'Biz Plus'

  static errRetry = 0

  // system 변수에서 재 할당됨
  static USER_PERMISSION = [
    { 'groupName': '시스템관리자', 'permission': 1 },
    { 'groupName': '경영관리자', 'permission': 2 },
    { 'groupName': '헤드헌터', 'permission': 4 },
    { 'groupName': '일반관리자', 'permission': 8 },
    { 'groupName': '재택근무자', 'permission': 16 }
  ]
  static 재택근무자 = 16
  static SYSTEM_ADMIN = 1
  static CRUD_ALLOW_경영 = 1 | 2
  static CRUD_ALLOW_경영_컨설턴트 = 1 | 2 | 4
  static CRUD_ALLOW_ALL = 1 | 2 | 4 | 8

  // packet command
  static CONNECT = 0x0000;
  static LOGOUT = 0x0001;
  static EXEC_PROC = 0x0011;
  static EXEC_PROC_STREAM = 0x0012;
  static EXEC_PROC_POI = 0x0021;
  static CONV_GEO_XY = 0x0022;
  static PROC_ALLOC = 0x0031;
  static PAY_CREDIT_CARD = 0x0101;
  static CANCEL_CREDIT_CARD = 0x0102;
  static CLOSE_FORCE = 0xF001;

  // packet result
  static SUCCESS = 0
  static FAILE = -1
  static SYSTEM_ERROR = -2
  static DATABASE_ERROR = -3
  static NETWORK_ERROR = -4;
  static WRONG_FILE = -5;
  static ERROR_USER_DEFINE_MSG = -7;
  static IGNORE = -10;

  // WAS Error Reponse
  static UNAUTHORIZED = 401
  static NOT_FOUND = 404
  static FORBIDDEN = 403
  static BAD_REQUEST = 400
  static NOT_ACCEPTABLE = 406
  static GENERRAL_ERROR = 500
  static DUPLICATE_LOGIN = 1009
  static REFRESH_TOKEN = 511

  // 공통코드
  static 지원자진행단계 = 'B00'
  static 계약단계 = 'B01'
  static 유치경로 = 'B02'
  static 회사규모 = 'B03'
  static 주거조건 = 'B05'
  static 채용단계 = 'B04'
  static 모집분야 = 'B06'
  static 프로필입수경로 = 'B07'
  static 외국어능력 = 'B08'
  static 최종학력 = 'B09'
  static 직책 = 'B10'

  static 등록완료 = '등록완료'
  static 최종합격 = '최종합격'
  static 제안성공 = '제안성공'
  static 제안실패 = '제안실패'
  static 외국어무관 = '외국어무관'

  static 입금완료='입금완료'

  // 첨부파일유형
  static 고객사첨부파일 = 0
  static 채용정보첨부파일 = 1
  static 지원자첨부파일 = 2

  // LOOKUP
  static 재직여부Lookup = [
    {
      코드명: '재직중'
    },
    {
      코드명: '구직중'
    }
  ]
  static YN_LOOKUP = [
    {
      코드명: 'N'
    },
    {
      코드명: 'Y'
    }
  ]
  static 상장여부 = [
    {
      코드명: '상장'
    },
    {
      코드명: '비상장'
    }
  ]
  static 게재비게재 = [
    {
      코드명: '게제'
    },
    {
      코드명: '비게제'
    }
  ]
  static 코웍단독 = [
    {
      코드명: '코웍'
    },
    {
      코드명: '단독'
    }
  ]
  static 요구학력 = [
    {
      코드명: '박사'
    },
    {
      코드명: '대학원'
    },
    {
      코드명: '대졸'
    },
    {
      코드명: '전문대졸'
    },
    {
      코드명: '고졸'
    },
    {
      코드명: '중졸'
    },
    {
      코드명: '무관'
    }
  ]
  static 졸업여부 = [
    {
      코드명: '졸업'
    },
    {
      코드명: '수료'
    },
    {
      코드명: '중퇴'
    }
  ]
  static 상중하 = [
    {
      코드명: '상'
    },
    {
      코드명: '중'
    },
    {
      코드명: '하'
    }
  ]
  static 남녀 = [
    {
      코드명: '남'
    },
    {
      코드명: '여'
    },
    {
      코드명: '무관'
    }
  ]
  static 연령대 = [
    {
      코드명: '10대'
    },
    {
      코드명: '20대'
    },
    {
      코드명: '30대'
    },
    {
      코드명: '40대'
    },
    {
      코드명: '50대이상'
    },
    {
      코드명: '무관'
    }
  ]
  static 시도 = [
    {
      코드명: '서울'
    },
    {
      코드명: '부산'
    },
    {
      코드명: '광주'
    },
    {
      코드명: '인천'
    },
    {
      코드명: '대전'
    },
    {
      코드명: '강원'
    },
    {
      코드명: '경기'
    },
    {
      코드명: '충북'
    },
    {
      코드명: '충남'
    },
    {
      코드명: '전남'
    },
    {
      코드명: '전북'
    },
    {
      코드명: '경남'
    },
    {
      코드명: '경북'
    }

  ]
  static 시도 = [
    {
      코드명: '서울'
    },
    {
      코드명: '부산'
    },
    {
      코드명: '인천'
    },
    {
      코드명: '광주'
    },
    {
      코드명: '대전'
    },
    {
      코드명: '강원'
    },
    {
      코드명: '경기'
    },
    {
      코드명: '경남'
    },
    {
      코드명: '경북'
    },
    {
      코드명: '전남'
    },
    {
      코드명: '전북'
    },
    {
      코드명: '제주'
    },
    {
      코드명: '충남'
    },
    {
      코드명: '충북'
    },
    {
      코드명: '기타'
    }
  ]
  static FEE_REQ_LOOKUP = [
    {
      코드명: '미청구'
    },
    {
      코드명: '청구'
    },
    {
      코드명: '입금완료'
    }
  ]
  static COWORK_LOOKUP = [
    {
      코드명: '단독'
    },
    {
      코드명: '코웍'
    }
  ]
}
